"use client";

import React, { useEffect } from "react";
import Ordered_Card from "../../../common-components/ordered_card/Ordered_Card";
import { useDispatch, useSelector } from "react-redux";
import { getAllOrder } from "../../../../features/order/orderSlice";
import { encodeId, OrderStatusIds } from "../../../../utils/common";
import "./Order_History.css";
const Order_History = ({ type, onOpenOrderDetails }) => {
  const dispatch = useDispatch();
  const allOrders = useSelector((state) => state.order.allOrders);

  useEffect(() => {
    const statusIds = [OrderStatusIds.Delivered];
    dispatch(getAllOrder({ order_status_id: statusIds }));
  }, [dispatch]);

  return (
    <section className="Order_History Ordered">
      <div className="order_table">
        <div className="row table_row ">
          <div className="col-md-3 ">
            <p className="table_head product_head">Order</p>
          </div>

          <div className="col-md-2 ">
            <p className="table_head table_headd">Status</p>
          </div>

          <div className="col-md-2 ">
            <p className="table_head table_headd">Price</p>
          </div>

          <div className="col-md-2 deliver-col">
            <p className="table_head table_headd table-date">Delivery date</p>
          </div>

          <div className="col-md-2 ">
            {/* <p className="table_head">Action</p> */}
          </div>
        </div>
      </div>

      <div className="all_cards_holder">
        {allOrders?.data?.map((item) => {
          return (
            <Ordered_Card
              data={item}
              showTrackOrder={false}
              track_order_text="Track Now"
              baseLike={`/order-details/${encodeId(item?.id)}`}
              type={type}
              showStatus={true}
              onOpenOrderDetails={onOpenOrderDetails}
            />
          );
        })}
      </div>

      <div className="no_data_main_div">
        <p className="no_data_text">No more orders to show</p>
      </div>
    </section>
  );
};

export default Order_History;
